import React from 'react';
import { Link } from 'react-router-dom';

interface FormButtonsProps {
  cancelText?: string;
  cancelTo?: string;
  onCancel?: () => void;
  submitText: string;
  isSubmitting?: boolean;
  disabled?: boolean;
  className?: string;
}

const FormButtons: React.FC<FormButtonsProps> = ({
  cancelText = 'Cancel',
  cancelTo,
  onCancel,
  submitText,
  isSubmitting = false,
  disabled = false,
  className = ''
}) => {
  const CancelButton = () => {
    const buttonClasses = `
      px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium 
      text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 
      focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200
    `;

    if (cancelTo) {
      return (
        <Link to={cancelTo} className={buttonClasses}>
          {cancelText}
        </Link>
      );
    }

    if (onCancel) {
      return (
        <button type="button" onClick={onCancel} className={buttonClasses}>
          {cancelText}
        </button>
      );
    }

    return null;
  };

  return (
    <div className={`flex justify-end gap-3 pt-6 border-t border-gray-200 ${className}`}>
      <CancelButton />
      <button
        type="submit"
        disabled={disabled || isSubmitting}
        className={`
          px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium 
          text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 
          focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 
          disabled:cursor-not-allowed transition-colors duration-200
          ${isSubmitting ? 'animate-pulse' : ''}
        `}
      >
        {isSubmitting ? (
          <div className="flex items-center">
            <div className="animate-spin -ml-1 mr-3 h-4 w-4 text-white">
              <div className="h-4 w-4 border-2 border-white border-t-transparent rounded-full"></div>
            </div>
            {isSubmitting && submitText.includes('Creating') ? 'Creating...' : 
             isSubmitting && submitText.includes('Updating') ? 'Updating...' : 
             'Saving...'}
          </div>
        ) : (
          submitText
        )}
      </button>
    </div>
  );
};

export default FormButtons;